var render = function render(){var _vm=this,_c=_vm._self._c;return _c('b-input',{class:{'clearable': !!_vm.input},attrs:{"placeholder":_vm.placeholder,"icon-right":"close","icon-right-clickable":!!_vm.input},on:{"icon-right-click":_vm.clear,"input":_vm.changeByUser,"focus":_vm.selectAll},model:{value:(_vm.input),callback:function ($$v) {_vm.input=$$v},expression:"input"}})
}
var staticRenderFns = []

export { render, staticRenderFns }